import { DESKTOP_ANALYTICS_EVENTS } from './declarations';
import { ClientInfo, UtilizationInfo, DesktopAnalytics } from './types';
import { EventEmitter } from '../event-emitter';

type CollectedInfo = {
    [DESKTOP_ANALYTICS_EVENTS.UTILIZATION]?: UtilizationInfo;
    [DESKTOP_ANALYTICS_EVENTS.CLIENT_INFO]?: ClientInfo;
};

class DesktopAnalyticsCollector extends EventEmitter {
    lastInfo: CollectedInfo = {};
    persistentInfo: CollectedInfo = {};
    unsubscribe: null | (() => void) = null;
    isUnavailable = false;

    startCollecting(desktopAnalytics?: DesktopAnalytics): void {
        if (this.unsubscribe || this.isUnavailable) return;

        if (!desktopAnalytics) {
            this.isUnavailable = true;
            return;
        }

        const utilizatonSubId = desktopAnalytics.subscribe(
            DESKTOP_ANALYTICS_EVENTS.UTILIZATION,
            (info: UtilizationInfo) => {
                this.lastInfo[DESKTOP_ANALYTICS_EVENTS.UTILIZATION] = info;
                this.persistentInfo[DESKTOP_ANALYTICS_EVENTS.UTILIZATION] = info;
                this.emit(DESKTOP_ANALYTICS_EVENTS.UTILIZATION, info);
            }
        );
        const clientInfoSubId = desktopAnalytics.subscribe(
            DESKTOP_ANALYTICS_EVENTS.CLIENT_INFO,
            (info: ClientInfo) => {
                this.lastInfo[DESKTOP_ANALYTICS_EVENTS.CLIENT_INFO] = info;
                this.persistentInfo[DESKTOP_ANALYTICS_EVENTS.CLIENT_INFO] = info;
                this.emit(DESKTOP_ANALYTICS_EVENTS.CLIENT_INFO, info);
            }
        );

        this.unsubscribe = () => {
            desktopAnalytics.removeSubscription(
                DESKTOP_ANALYTICS_EVENTS.UTILIZATION,
                utilizatonSubId
            );
            desktopAnalytics.removeSubscription(
                DESKTOP_ANALYTICS_EVENTS.CLIENT_INFO,
                clientInfoSubId
            );
        };
    }

    stopCollecting(): void {
        this.unsubscribe?.();
        this.unsubscribe = null;
        this.lastInfo = {};
    }

    getInfo(): CollectedInfo {
        return this.lastInfo;
    }

    /**
     * Use getPersistentInfo only when you encounter issues RCV-110780 with lastInfo being cleared before retrieving necessary properties due to race conditions.
     * This method provides access to data that are not cleared upon calling stopCollecting.
     */
    getPersistentInfo(): CollectedInfo {
        return this.persistentInfo;
    }
}

export const desktopAnalyticsCollector = new DesktopAnalyticsCollector();
